import { useTranslation } from 'react-i18next';

const testimonials = [
  {
    name: 'Marco R.',
    location: 'Milano, Italia',
    title: 'Finalmente ho capito come funziona',
    text: 'Itaobuy Spreadsheet mi ha aiutato a organizzare meglio le mie ricerche. Prima passavo ore a confrontare prodotti, ora ho tutto sotto controllo in un unico foglio.',
    rating: 5,
  },
  {
    name: 'Giulia B.',
    location: 'Roma, Italia',
    title: 'Guida chiarissima e utile',
    text: 'La guida in italiano è fatta molto bene. Spiega ogni passaggio in modo semplice e anche chi non è esperto può seguire facilmente.',
    rating: 5,
  },
  {
    name: 'Alessandro F.',
    location: 'Torino, Italia',
    title: 'Ottimo per risparmiare tempo',
    text: 'Utilizzo Itaobuy Spreadsheet da qualche mese e devo dire che il risparmio di tempo è notevole. Consigliato a tutti.',
    rating: 4,
  },
  {
    name: 'Francesca M.',
    location: 'Napoli, Italia',
    title: 'Informazioni ben organizzate',
    text: 'Apprezzo molto l\'organizzazione delle informazioni. I consigli sulla sicurezza sono particolarmente utili per chi acquista online.',
    rating: 5,
  },
  {
    name: 'Lorenzo P.',
    location: 'Bologna, Italia',
    title: 'Guida completa e affidabile',
    text: 'Una risorsa davvero completa per chi vuole acquistare prodotti dalla Cina in modo più consapevole e organizzato.',
    rating: 5,
  },
  {
    name: 'Sofia D.',
    location: 'Firenze, Italia',
    title: 'Semplice da usare',
    text: 'Ho iniziato da poco ma già vedo i benefici. L\'approccio passo-passo è perfetto per i principianti.',
    rating: 4,
  },
];

const comparisonMethods = [
  { method: 'Itaobuy Spreadsheet', facilita: '⭐⭐⭐⭐⭐', controllo: '⭐⭐⭐⭐⭐', tempo: 'Basso' },
  { method: 'Ricerca manuale', facilita: '⭐⭐', controllo: '⭐⭐', tempo: 'Alto' },
  { method: 'Marketplace tradizionale', facilita: '⭐⭐⭐', controllo: '⭐⭐⭐', tempo: 'Medio' },
];

export default function TestimonialsSection() {
  const { t } = useTranslation();

  return (
    <>
      <section className="py-16 md:py-24 bg-secondary-50/60 px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center gap-2 mb-4">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-xs text-foreground-500 uppercase tracking-wider">Testimonianze</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
              Cosa dicono gli utenti
            </h2>
            <p className="text-foreground-500 text-sm">Esperienze reali di chi utilizza Itaobuy Spreadsheet</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {testimonials.map((t, idx) => (
              <div
                key={idx}
                className="bg-background-50 rounded-2xl p-6"
              >
                <div className="flex gap-0.5 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`ri-star-fill text-sm ${i < t.rating ? 'text-amber-400' : 'text-background-300'}`}
                    ></i>
                  ))}
                </div>
                <h4 className="font-semibold text-foreground-800 mb-2">{t.title}</h4>
                <p className="text-xs text-foreground-500 leading-relaxed mb-4">{t.text}</p>
                <div className="flex items-center gap-3 pt-4 border-t border-background-100">
                  <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center text-accent-600 text-xs font-semibold">
                    {t.name.charAt(0)}
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-800">{t.name}</p>
                    <p className="text-xs text-foreground-400">{t.location}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-background-50 px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8 text-center">
            {t('section5.title')}
          </h2>
          <div className="overflow-x-auto">
            <table className="w-full max-w-2xl mx-auto text-sm border-collapse">
              <thead>
                <tr className="border-b border-background-200">
                  <th className="text-left py-3 pr-4 font-semibold text-foreground-800">Metodo</th>
                  <th className="text-center py-3 pr-4 font-semibold text-foreground-800">Facilità</th>
                  <th className="text-center py-3 pr-4 font-semibold text-foreground-800">Controllo</th>
                  <th className="text-center py-3 font-semibold text-foreground-800">Tempo</th>
                </tr>
              </thead>
              <tbody>
                {comparisonMethods.map((row, idx) => (
                  <tr key={idx} className={`border-b border-background-100 ${idx === 0 ? 'bg-accent-50/40' : ''}`}>
                    <td className={`py-3 pr-4 ${idx === 0 ? 'font-semibold text-accent-600' : 'text-foreground-600'}`}>{row.method}</td>
                    <td className="text-center py-3 pr-4 text-xs">{row.facilita}</td>
                    <td className="text-center py-3 pr-4 text-xs">{row.controllo}</td>
                    <td className="text-center py-3 text-xs font-medium text-foreground-700">{row.tempo}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </>
  );
}